export class YandexCounter {

    constructor(options) {
        this.options = { ...{id: null}, ...options };
    }

    send(action) {
        try {
            if (typeof ym !== 'undefined') {
                ym(this.options.id, 'reachGoal', action);
            }
        } catch (e) {
            console.error(e);
        }
    }

    onSubscribe() {
        this.send('news_subscribe');
    }

    onClickRegister() {
        this.send('register');
    }

    onClickRegistered() {
        this.send('registered');
    }

    onClickCart(position) {
        if (position === 'header') {
            this.send('go_to_cart_header');
        } else if (position === 'product') {
            this.send('go_to_cart_product');
        }
    }

    onClickBuy() {
        this.send('click_cart');
    }

    onClickPhone() {
        this.send('zvonok');
    }

    onCheckout(step, products) {
        if (step === 2) {
            this.send('confirm');
        }
    }

    onPurchased(order, products) {
        this.send('confirmed');
    }

    onAddToCart(product) {
        this.send('add_to_cart');
    }

    onApplyPromoCode() {
        this.send('promocode');
    }

    onOneClickOpen() {
        this.send('kupit-v-1-click');
    }

    onOneClickPurchased() {
        this.send('kupit-v-1-click-send');
    }

    onLocationUndefined() {
        this.send('location-undefined');
    }
}
